import { Directive, AfterContentInit, inject } from '@angular/core';
import { NgForm } from '@angular/forms';

/**
 * Sets default values and behaviour for form components
 * that are universally used in H1.
 *
 * Default values are as follows:
 * ngFormOptions: {updateOn: 'blur'}
 */
@Directive( {
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'form',
    standalone: false
} )
export class HisFormDefaultsDirective implements AfterContentInit {
    private ngForm = inject(NgForm, { host: true, optional: true, self: true });


    ngAfterContentInit(): void {
        if ( this.ngForm ) {
            // console.log('Pre: ' + JSON.stringify(this.ngForm.options));

            // updateOn: 'blur' setzen, wenn sonst nichts für 'updateOn' gesetzt ist
            if ( this.ngForm.options ) {
                if ( !this.ngForm.options.updateOn ) {
                    this.ngForm.options.updateOn = 'blur';
                }
            } else {
                this.ngForm.options = { updateOn: 'blur' };
            }

            // console.log('Post: ' + JSON.stringify(this.ngForm.options));
        }
    }
}
